import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    first_name: "",
    last_name: "",
    phone_number: "",
    dob: "",
};

export const name = "stepone";

const slice = createSlice({
    name,
    initialState,
    reducers: {
        setFirstName: (state, action) => {
            state.first_name = action.payload;
        },
        setLastName: (state, action) => {
            state.last_name = action.payload;
        },
        setPhoneNumber: (state, action) => {
            state.phone_number = action.payload;
        },
        setDOB: (state, action) => {
            state.dob = action.payload;
        },
        setStorisID: (state, action) => {
            state.storis_id = action.payload;
        },
        setUserName: (state, action) => {
            state.user_name = action.payload;
        },
        reset: (state) => {
            state.first_name = ""
            state.last_name = ""
            state.phone_number = ""
            state.dob = null
        },
        resetAll: (state) => {
            state.first_name = ""
            state.last_name = ""
            state.phone_number = ""
            state.dob = null
            state.storis_id = null
            state.user_name = null
        }
    },
});

export const { actions, reducer } = slice;

export const getFirstName = (state) => state.stepone.first_name;
export const getLastName = (state) => state.stepone.last_name;
export const getPhoneNumber = (state) => state.stepone.phone_number;
export const getUserName = (state) => state.stepone.user_name;
export const getDOB = (state) => state.stepone.dob;